    <div mat-dialog-content class="dealers">
        <!-- <h1 mat-dialog-title>Select a dealer to view their dashboard</h1> -->
        <!-- <mat-form-field class="searchbox">
            <input matInput (keyup)="searchGroups()" placeholder="Search..." [(ngModel)]="searchValue">
        </mat-form-field> -->
        <mat-progress-bar mode="indeterminate" *ngIf="isDealersLoading"></mat-progress-bar>
        <div class="dialog-container">
            <!-- <app-data-table *ngIf="!isDealersLoading" [displayedColumns]="dealerColumns" [tableData]="dealers"
                [initSortColumn]="0" [initSortDirection]="'asc'" [selectable]="true" [selection]="selection">
            </app-data-table> -->
            <app-choose-users-table *ngIf="dealers != null && userType === 'dealeradmin'" [selection]="selection" [dealers]="dealers"
                [currentOffset]="currentOffset" [currentTake]="currentTake"></app-choose-users-table>
        </div>
    </div>
    <div mat-dialog-actions class="button-container">
        <button mat-raised-button (click)="onNoClick()">Close</button>
        <button mat-raised-button cdkFocusInitial (click)="onGoClick()" [disabled]="selection.selected.length < 1" color="accent" id="goBtn">Go</button>
    </div>